
import React, { useState } from 'react';
import { QuoteFormData } from '../types';

const EstimateForm: React.FC = () => {
  const [formData, setFormData] = useState<QuoteFormData>({
    fullName: '',
    phone: '',
    roofType: 'Shingle',
    serviceNeeded: 'New Roof',
    address: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        fullName: '',
        phone: '',
        roofType: 'Shingle',
        serviceNeeded: 'New Roof',
        address: '',
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1500);
  };

  return (
    <section className="py-24 bg-background-light dark:bg-background-dark">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-dark-gray rounded-[2rem] overflow-hidden shadow-2xl flex flex-col lg:flex-row min-h-[650px]">
          <div className="flex-1 p-8 sm:p-12 lg:p-16">
            <h2 className="text-3xl lg:text-4xl font-black text-white mb-6">Get Your Free Estimate</h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Full Name</label>
                <input 
                  required
                  value={formData.fullName}
                  onChange={(e) => setFormData({...formData, fullName: e.target.value})}
                  className="bg-gray-800/50 border-gray-700 text-white rounded-xl p-3.5 focus:ring-primary focus:border-primary transition-all placeholder:text-gray-600" 
                  placeholder="John Doe" 
                  type="text" 
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Phone Number</label>
                <input 
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="bg-gray-800/50 border-gray-700 text-white rounded-xl p-3.5 focus:ring-primary focus:border-primary transition-all placeholder:text-gray-600" 
                  placeholder="(555) 000-0000" 
                  type="tel" 
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Roof Type</label>
                <select 
                  value={formData.roofType}
                  onChange={(e) => setFormData({...formData, roofType: e.target.value})}
                  className="bg-gray-800/50 border-gray-700 text-white rounded-xl p-3.5 focus:ring-primary focus:border-primary transition-all"
                >
                  <option>Shingle</option>
                  <option>Tile</option>
                  <option>Metal</option>
                  <option>Flat/Other</option>
                </select>
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Service Needed</label>
                <select 
                  value={formData.serviceNeeded}
                  onChange={(e) => setFormData({...formData, serviceNeeded: e.target.value})}
                  className="bg-gray-800/50 border-gray-700 text-white rounded-xl p-3.5 focus:ring-primary focus:border-primary transition-all"
                >
                  <option>New Roof</option>
                  <option>Repair</option>
                  <option>Inspection</option>
                  <option>Storm Assessment</option>
                </select>
              </div>
              <div className="sm:col-span-2 flex flex-col gap-2">
                <label className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Property Address</label>
                <input 
                  required
                  value={formData.address}
                  onChange={(e) => setFormData({...formData, address: e.target.value})}
                  className="bg-gray-800/50 border-gray-700 text-white rounded-xl p-3.5 focus:ring-primary focus:border-primary transition-all placeholder:text-gray-600" 
                  placeholder="123 Palm Ave, Margate, FL" 
                  type="text" 
                />
              </div>
              
              <button 
                disabled={isSubmitting}
                className={`sm:col-span-2 py-4 rounded-xl font-bold text-lg transition-all mt-4 flex items-center justify-center gap-2 ${
                  isSuccess ? 'bg-green-500 text-white' : 'bg-primary text-white hover:bg-blue-600'
                }`}
              >
                {isSubmitting ? 'Sending...' : isSuccess ? 'Request Received!' : 'Submit Request'}
              </button>
            </form>
          </div>

          <div className="lg:w-1/3 min-h-[400px] relative">
            <div 
              className="absolute inset-0 grayscale contrast-125 brightness-[0.4] bg-center bg-cover"
              style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1524661135-423995f22d0b?auto=format&fit=crop&q=80&w=600")' }}
            ></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center bg-primary/20 backdrop-blur-[2px]">
              <div className="bg-white p-8 rounded-3xl shadow-2xl flex flex-col items-center gap-4 max-w-[320px]">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center text-primary font-black">M</div>
                <div>
                  <h4 className="font-black text-xl text-dark-gray mb-1">Serving Broward</h4>
                  <p className="text-sm text-gray-500 font-medium">Margate • Coral Springs • Parkland</p>
                </div>
                <div className="w-full h-px bg-gray-100 my-2"></div>
                <a href="tel:5551234567" className="mt-2 text-dark-gray font-bold text-lg hover:text-primary transition-colors underline decoration-primary decoration-4 underline-offset-4">
                  (555) 123-4567
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EstimateForm;
